import { ModalComponent } from '../baseComponents';

export const ReclaimModal = ({ OpenReclaim, setOpenReclaim }) => {
  const handleCancel = () => {
    setOpenReclaim(false);
  };

  return (
    <>
      <ModalComponent
        centered={true}
        open={OpenReclaim}
        handleSubmit={''}
        handleCancel={handleCancel}
        className={''}
        submitButtonText=""
        cancelButtonText=""
        closable={true}
        additionalBody={
          <>
            <div className="flex flex-col items-center mt-2">
              <iframe
                src="https://app.reclaim.ai/e/edaf98db-e036-4380-acb7-c2d39e9de585"
                width="100%"
                height="700px"
                style={{
                  outline: 'none',
                  border: 'none',
                  marginTop: '30px',
                  borderRadius: '20px',
                }}
              ></iframe>
            </div>
          </>
        }
      />
    </>
  );
};
